const STORAGE_PREFIX = 'planificador_viajes_';

export const saveMonthData = (monthIndex, data, year = 2026) => {
  try {
    const key = `${STORAGE_PREFIX}${year}_month_${monthIndex}`;
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Error guardando datos:', error);
  }
};

export const loadMonthData = (monthIndex, year = 2026) => {
  try {
    const key = `${STORAGE_PREFIX}${year}_month_${monthIndex}`;
    let data = localStorage.getItem(key);
    
    // Compatibilidad con datos antiguos (sin año en la clave)
    if (!data && year === 2026) {
      const oldKey = `${STORAGE_PREFIX}2026_month_${monthIndex}`;
      data = localStorage.getItem(oldKey);
    }
    
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error cargando datos:', error);
    return null;
  }
};

export const getAllMonthData = (year = 2026) => {
  const allData = [];
  for (let i = 0; i < 12; i++) {
    allData.push(loadMonthData(i, year));
  }
  return allData;
};

export const getDaysInMonth = (monthIndex, year) => {
  return new Date(year, monthIndex + 1, 0).getDate();
};

export const getFirstDayOfMonth = (monthIndex, year) => {
  return new Date(year, monthIndex, 1).getDay();
};

